/** Очередь приёмки — плитками с превью, чтобы видеть содержание, а не только названия. */
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import { Page, PageHeader } from '../components/Layout';
import { Empty, Loading, OverduePill } from '../components/ui';
import { bytes, duration, money } from '../lib/format';
import type { Video } from '../lib/types';

export function ReviewListPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['review-queue'],
    queryFn: () => api.get<Video[]>('/api/videos/review'),
    refetchInterval: 60_000,
  });

  return (
    <>
      <PageHeader title="Приёмка" sub={`${data?.length ?? 0} в очереди`} />
      <Page>
        {isLoading ? (
          <Loading rows={3} />
        ) : !data?.length ? (
          <div className="card">
            <Empty title="Очередь пуста" hint="Все видео приняты" />
          </div>
        ) : (
          <div className="grid grid-cols-3 gap-3">
            {data.map((v) => {
              const final = v.files?.find((f) => f.kind === 'FINAL');
              const proxyReady = v.files?.some((f) => f.kind === 'PROXY');
              return (
                <Link
                  key={v.id}
                  to={`/review/${v.id}`}
                  className="card p-0 overflow-hidden hover:border-line2 transition-colors"
                >
                  {/* Кадр из видео или обложка, если её сделали.
                      Без картинки все карточки в очереди неразличимы.
                      Треугольник поверх — подсказка, что это видео */}
                  <div className="relative aspect-video">
                    {v.thumbUrl ? (
                      <img
                        src={v.thumbUrl}
                        alt=""
                        loading="lazy"
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className="w-full h-full bg-gradient-to-br from-[#3E2C63] to-[#1E2745]" />
                    )}
                    <div className="absolute inset-0 grid place-items-center text-2xl text-white/90 bg-black/25 hover:bg-black/10 transition-colors">
                      ▶
                    </div>
                  </div>
                  <div className="p-4">
                    <div className="font-bold text-sm truncate">{v.task.title}</div>
                    <div className="text-[11.5px] text-muted2 mt-1">
                      видео {v.index} · {v.editor?.displayName ?? v.worker.displayName}
                      {final?.durationSec ? ` · ${duration(final.durationSec)}` : ''}
                      {final ? ` · ${bytes(final.sizeBytes)}` : ''}
                    </div>
                    {!proxyReady && (
                      <div className="text-[11px] text-warn mt-1.5">превью готовится…</div>
                    )}
                    <div className="flex justify-between items-center mt-3">
                      {v.isOverdue ? (
                        <OverduePill />
                      ) : (
                        <span className="text-[11.5px] text-muted2">
                          доработок: {v.revisionCount}
                        </span>
                      )}
                      <span className="mono font-bold">{money(v.priceShoot + v.priceEdit)}</span>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        )}
      </Page>
    </>
  );
}
